import { getTemperatureWarningTagColorName } from '../../../../utils/vehicleUtils'

export const getLogColumns = (t) => [
  {
    id: 'startTimeString',
    label: t('climateSystem.tempReport.from'),
    width: 120,
    hide: [],
    align: 'left'
  },
  {
    id: 'endTimeString',
    label: t('climateSystem.tempReport.to'),
    width: 120,
    hide: [],
    align: 'left'
  },
  {
    id: 'vehicle',
    label: t('climateSystem.tempReport.vehicle'),
    width: 250,
    hide: [],
    align: 'center'
  },
  {
    id: 'thermometerName',
    label: t('climateSystem.tempReport.location'),
    hide: []
  },
  {
    id: 'temperature',
    label: t('climateSystem.tempReport.temperature'),
    isTag: true,
    hasGuard: true,
    tagColor: getTemperatureWarningTagColorName,
    textColor: 'black',
    hide: []
  },
]
export const getTemplateColumns = (t) => [
  {
    id: 'templateName',
    label: t('climateSystem.settings.template'),
    width: 350,
    hide: [],
    align: 'left'
  }
]

export const getVehicleTemplateColumns = (t) => [
  {
    id: 'vehicleName',
    label: t('climateSystem.settings.vehicleName'),
    minWidth: 200,
    hide: [],
    align: 'left'
  },
  {
    id: 'organisation',
    label: t('climateSystem.settings.organisation'),
    minWidth: 350,
    hide: [],
    align: 'left'
  },
  {
    id: 'templateName',
    label: t('climateSystem.settings.template'),
    minWidth: 300,
    hide: [],
    align: 'left'
  }
]

export const getVehicleReportColumns = (t) => [
  {
    id: 'vehicleName',
    label: t('climateSystem.settings.vehicleName'),
    minWidth: 200,
    hide: [],
    align: 'left'
  }
]

export const vehicle_sensor_columns = (t) => [
  {
    id: 'vehicleName',
    label: t('climateSystem.tempReport.vehicle'),
    width: 260,
    hide: [],
    align: 'left'
  },
  {
    id: "numberOfIncidents",
    label: t('climateSystem.tempHistory.warning'),
    minWidth: 200,
    align: "left"
  },
]

export const sensor_log_columns = (t) => [
  {
    id: 'date',
    label: t('climateSystem.tempHistory.date'),
    isSortable: true,
    width: 169,
    isSmallColumn: true,
    align: 'left'
  },
  {
    id: 'time',
    label: t('climateSystem.tempHistory.time'),
    isSortable: true,
    width: 115,
    isSmallColumn: true,
    align: 'left'
  },
  {
    id: 'duration',
    label: t('climateSystem.tempHistory.duration'),
    isSortable: true,
    width: 169,
    align: 'left'
  },
  {
    id: 'temperature',
    label: t('climateSystem.tempHistory.temperature'),
    isSortable: true,
    width: 180,
    align: 'left',
    icon: true,
    iconPosition: 'before'
  },
  {
    id: 'emails',
    label: t('climateSystem.tempHistory.emailsSent'),
    isSortable: true,
    minWidth: 200,
    isSmallColumn: true,
    align: 'left'
  },
  {
    id: 'chart',
    label: '',
    minWidth: 80,
    align: 'right',
  }
]